// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invite-accept-page {
  --invite-panel: var(--color-bg-canvas-surface, #151619);
  --invite-subtle: var(--color-bg-input, #1b1c20);
  --invite-border: var(--color-border-input, rgba(255, 255, 255, 0.12));
  --invite-text: var(--color-text-primary, #f5f5f5);
  --invite-muted: var(--color-text-secondary, #9a9da4);
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: 32px 20px;
  background: var(--color-bg-root, #0d0e10);
  color: var(--invite-text);
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
}

.invite-accept-card {
  width: min(100%, 560px);
  padding: 28px;
  background: var(--invite-panel);
  border: 1px solid var(--invite-border);
  border-radius: 8px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.2);
}

.invite-accept-header {
  padding-bottom: 20px;
}

.invite-accept-brand {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 28px;
  color: var(--invite-muted);
  font-size: 12px;
  font-weight: 500;
}

.invite-accept-eyebrow {
  margin: 0 0 7px;
  color: var(--invite-muted);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.invite-accept-card h1 {
  margin: 0;
  color: var(--invite-text);
  font-size: clamp(23px, 5vw, 29px);
  font-weight: 570;
  letter-spacing: -0.025em;
  line-height: 1.15;
}

.invite-accept-subtitle,
.invite-accept-result > p:not(.invite-accept-eyebrow) {
  margin: 10px 0 0;
  color: var(--invite-muted);
  font-size: 14px;
  line-height: 1.55;
}

.invite-accept-summary {
  margin: 0 0 22px;
  padding: 4px 14px;
  background: var(--invite-subtle);
  border: 1px solid var(--invite-border);
  border-radius: 6px;
}

.invite-accept-summary > div {
  display: grid;
  grid-template-columns: 116px minmax(0, 1fr);
  gap: 14px;
  padding: 10px 0;
  border-bottom: 1px solid var(--invite-border);
}

.invite-accept-summary > div:last-child {
  border-bottom: 0;
}

.invite-accept-summary dt {
  color: var(--invite-muted);
  font-size: 12px;
}

.invite-accept-summary dd {
  overflow: hidden;
  margin: 0;
  color: var(--invite-text);
  font-size: 12px;
  font-weight: 500;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.invite-accept-tabs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3px;
  padding: 3px;
  margin-bottom: 14px;
  background: var(--invite-subtle);
  border: 1px solid var(--invite-border);
  border-radius: 6px;
}

.invite-accept-tabs button {
  min-height: 34px;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: var(--invite-muted);
  font: inherit;
  font-size: 12px;
  font-weight: 550;
  cursor: pointer;
}

.invite-accept-tabs button[aria-selected='true'] {
  background: var(--invite-panel);
  color: var(--invite-text);
  box-shadow: inset 0 0 0 1px var(--invite-border);
}

.invite-accept-tabs button:disabled {
  cursor: wait;
  opacity: 0.55;
}

.invite-accept-form {
  display: grid;
  gap: 13px;
}

.invite-accept-form label {
  display: grid;
  gap: 6px;
  color: var(--invite-muted);
  font-size: 11px;
  font-weight: 600;
}

.invite-accept-form input {
  width: 100%;
  height: 40px;
  box-sizing: border-box;
  padding: 0 11px;
  border: 1px solid var(--invite-border);
  border-radius: 5px;
  outline: none;
  background: var(--invite-subtle);
  color: var(--invite-text);
  font: inherit;
  font-size: 13px;
  transition: border-color 120ms ease, box-shadow 120ms ease;
}

.invite-accept-form input:focus {
  border-color: color-mix(in srgb, var(--invite-text) 45%, transparent);
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--invite-text) 8%, transparent);
}

.invite-accept-form input[readonly] {
  color: var(--invite-muted);
  cursor: default;
}

.invite-accept-password-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.invite-accept-primary,
.invite-accept-secondary,
.invite-accept-google {
  display: inline-flex;
  min-height: 40px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 14px;
  border-radius: 5px;
  font: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 120ms ease, border-color 120ms ease, opacity 120ms ease;
}

.invite-accept-primary {
  width: 100%;
  margin-top: 3px;
  border: 1px solid #f2f2f2;
  background: #f2f2f2;
  color: #141518;
}

.invite-accept-primary:hover:not(:disabled) {
  background: #ffffff;
  border-color: #ffffff;
}

.invite-accept-primary:disabled {
  opacity: 0.55;
  cursor: wait;
}

.invite-accept-secondary:disabled,
.invite-accept-google:disabled {
  opacity: 0.55;
  cursor: wait;
}

.invite-accept-tabs button:focus-visible,
.invite-accept-primary:focus-visible,
.invite-accept-secondary:focus-visible,
.invite-accept-google:focus-visible {
  outline: 2px solid color-mix(in srgb, var(--invite-text) 65%, transparent);
  outline-offset: 2px;
}

.invite-accept-secondary,
.invite-accept-google {
  border: 1px solid var(--invite-border);
  background: var(--invite-subtle);
  color: var(--invite-text);
}

.invite-accept-secondary:hover,
.invite-accept-google:hover {
  background: color-mix(in srgb, var(--invite-subtle) 75%, var(--invite-text) 7%);
}

.invite-accept-google {
  width: 100%;
}

.invite-accept-google img {
  width: 16px;
  height: 16px;
}

.invite-accept-divider {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 15px 0;
  color: var(--invite-muted);
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.invite-accept-divider::before,
.invite-accept-divider::after {
  height: 1px;
  flex: 1 1;
  background: var(--invite-border);
  content: '';
}

.invite-accept-account {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 11px 12px;
  margin-bottom: 12px;
  background: var(--invite-subtle);
  border: 1px solid var(--invite-border);
  border-radius: 5px;
}

.invite-accept-account div {
  display: grid;
  gap: 3px;
  min-width: 0;
}

.invite-accept-account span {
  color: var(--invite-muted);
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.invite-accept-account strong {
  overflow: hidden;
  font-size: 13px;
  text-overflow: ellipsis;
}

.invite-accept-account--mismatch {
  border-color: rgba(217, 119, 87, 0.45);
}

.invite-accept-mismatch p,
.invite-accept-transition p {
  margin: 0 0 12px;
  color: var(--invite-muted);
  font-size: 13px;
  line-height: 1.5;
}

.invite-accept-transition {
  padding: 14px;
  border: 1px solid rgba(217, 156, 87, 0.45);
  border-radius: 6px;
  background: rgba(217, 156, 87, 0.07);
}

.invite-accept-transition--blocked {
  border-color: rgba(217, 119, 87, 0.5);
  background: rgba(217, 119, 87, 0.075);
}

.invite-accept-transition-heading {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  margin-bottom: 12px;
}

.invite-accept-transition-heading > svg {
  flex: 0 0 auto;
  margin-top: 1px;
  color: #d99c57;
}

.invite-accept-transition--blocked .invite-accept-transition-heading > svg {
  color: #d97757;
}

.invite-accept-transition-heading > div {
  display: grid;
  gap: 3px;
}

.invite-accept-transition-heading span,
.invite-accept-transition-route small {
  color: var(--invite-muted);
  font-size: 9px;
  font-weight: 650;
  letter-spacing: 0.07em;
  line-height: 1.2;
  text-transform: uppercase;
}

.invite-accept-transition-heading strong {
  font-size: 13px;
  font-weight: 620;
  line-height: 1.35;
}

.invite-accept-transition-route {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 20px minmax(0, 1fr);
  align-items: center;
  gap: 8px;
  padding: 9px;
  margin-bottom: 11px;
  border: 1px solid var(--invite-border);
  border-radius: 5px;
  background: color-mix(in srgb, var(--invite-panel) 72%, transparent);
}

.invite-accept-transition-route > svg {
  color: var(--invite-muted);
}

.invite-accept-transition-route > div {
  display: grid;
  min-width: 0;
  gap: 3px;
}

.invite-accept-org-name {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}

.invite-accept-org-icon {
  display: grid;
  width: 24px;
  height: 24px;
  flex: 0 0 auto;
  overflow: hidden;
  place-items: center;
  border: 1px solid var(--invite-border);
  border-radius: 5px;
  background: var(--invite-panel);
  color: var(--invite-text);
  font-size: 10px;
  font-weight: 650;
}

.invite-accept-org-icon img {
  width: 100%;
  height: 100%;
  padding: 3px;
  object-fit: contain;
  background: #ffffff;
}

.invite-accept-transition-route > .invite-accept-transition-org {
  display: flex;
  align-items: center;
  gap: 7px;
}

.invite-accept-transition-org > div {
  display: grid;
  min-width: 0;
  gap: 3px;
}

.invite-accept-transition-route strong,
.invite-accept-transition-route span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.invite-accept-transition-route strong {
  color: var(--invite-text);
  font-size: 12px;
  font-weight: 580;
}

.invite-accept-transition-route span {
  color: var(--invite-muted);
  font-size: 10px;
}

.invite-accept-transition-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.invite-accept-transition-actions .invite-accept-primary {
  width: auto;
  margin: 0;
}

.invite-accept-error {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 11px;
  margin-top: 13px;
  border: 1px solid rgba(217, 119, 87, 0.4);
  border-radius: 5px;
  background: rgba(217, 119, 87, 0.07);
  color: #e1a18d;
  font-size: 12px;
  line-height: 1.4;
}

.invite-accept-error svg {
  flex: 0 0 auto;
  margin-top: 1px;
}

.invite-accept-footnote {
  margin: 18px 0 0;
  color: var(--invite-muted);
  font-size: 10px;
  line-height: 1.45;
  text-align: center;
}

.invite-accept-result {
  display: flex;
  min-height: 285px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.invite-accept-result .invite-accept-primary,
.invite-accept-result .invite-accept-secondary {
  width: auto;
  margin-top: 22px;
}

.invite-accept-status-icon {
  display: grid;
  width: 42px;
  height: 42px;
  place-items: center;
  margin-bottom: 18px;
  border: 1px solid var(--invite-border);
  border-radius: 50%;
  background: var(--invite-subtle);
}

.invite-accept-status-icon--success {
  color: #7fca9a;
}

.invite-accept-status-icon--error {
  color: #e1a18d;
}

.invite-accept-spinner {
  width: 28px;
  height: 28px;
  margin-bottom: 20px;
  border: 2px solid var(--invite-border);
  border-top-color: var(--invite-text);
  border-radius: 50%;
  animation: invite-spin 700ms linear infinite;
}

@keyframes invite-spin {
  to { transform: rotate(360deg); }
}

@media (max-width: 560px) {
  .invite-accept-page {
    align-items: start;
    padding: 16px 12px;
  }

  .invite-accept-card {
    padding: 22px 18px;
  }

  .invite-accept-brand {
    margin-bottom: 22px;
  }

  .invite-accept-password-row {
    grid-template-columns: 1fr;
  }

  .invite-accept-summary > div {
    grid-template-columns: 96px minmax(0, 1fr);
  }

  .invite-accept-transition-actions {
    align-items: stretch;
    flex-direction: column-reverse;
  }

  .invite-accept-transition-actions .invite-accept-primary,
  .invite-accept-transition-actions .invite-accept-secondary {
    width: 100%;
  }
}

@media (prefers-reduced-motion: reduce) {
  .invite-accept-spinner { animation-duration: 1.4s; }
  .invite-accept-primary,
  .invite-accept-secondary,
  .invite-accept-google { transition: none; }
}
`, "",{"version":3,"sources":["webpack://./src/InviteAcceptPage.css"],"names":[],"mappings":"AAAA;EACE,uDAAuD;EACvD,+CAA+C;EAC/C,qEAAqE;EACrE,iDAAiD;EACjD,oDAAoD;EACpD,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,yBAAyB;EACzB,kEAAkE;AACpE;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,+BAA+B;EAC/B,sCAAsC;EACtC,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,iCAAiC;EACjC,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,gCAAgC;EAChC,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,0BAA0B;EAC1B,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,sCAAsC;EACtC,kBAAkB;EAClB,aAAa;EACb,gCAAgC;EAChC,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,qEAAqE;EACrE,4EAA4E;AAC9E;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;;EAGE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,8EAA8E;AAChF;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,YAAY;AACd;;AAEA;;;;EAIE,0EAA0E;EAC1E,mBAAmB;AACrB;;AAEA;;EAEE,sCAAsC;EACtC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;;EAEE,+EAA+E;AACjF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;EACX,SAAO;EACP,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;EAEE,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;;EAEE,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yDAAyD;EACzD,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,sCAAsC;EACtC,kBAAkB;EAClB,oEAAoE;AACtE;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;EACtC,kBAAkB;EAClB,+BAA+B;EAC/B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,QAAQ;AACV;;AAEA;;EAEE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;EACtC,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sCAAsC;EACtC,oCAAoC;EACpC,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,oBAAoB;IACpB,8BAA8B;EAChC;;EAEA;;IAEE,WAAW;EACb;AACF;;AAEA;EACE,yBAAyB,wBAAwB,EAAE;EACnD;;0BAEwB,gBAAgB,EAAE;AAC5C","sourcesContent":[".invite-accept-page {\n  --invite-panel: var(--color-bg-canvas-surface, #151619);\n  --invite-subtle: var(--color-bg-input, #1b1c20);\n  --invite-border: var(--color-border-input, rgba(255, 255, 255, 0.12));\n  --invite-text: var(--color-text-primary, #f5f5f5);\n  --invite-muted: var(--color-text-secondary, #9a9da4);\n  min-height: 100vh;\n  display: grid;\n  place-items: center;\n  padding: 32px 20px;\n  background: var(--color-bg-root, #0d0e10);\n  color: var(--invite-text);\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n}\n\n.invite-accept-card {\n  width: min(100%, 560px);\n  padding: 28px;\n  background: var(--invite-panel);\n  border: 1px solid var(--invite-border);\n  border-radius: 8px;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.2);\n}\n\n.invite-accept-header {\n  padding-bottom: 20px;\n}\n\n.invite-accept-brand {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  margin-bottom: 28px;\n  color: var(--invite-muted);\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.invite-accept-eyebrow {\n  margin: 0 0 7px;\n  color: var(--invite-muted);\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.invite-accept-card h1 {\n  margin: 0;\n  color: var(--invite-text);\n  font-size: clamp(23px, 5vw, 29px);\n  font-weight: 570;\n  letter-spacing: -0.025em;\n  line-height: 1.15;\n}\n\n.invite-accept-subtitle,\n.invite-accept-result > p:not(.invite-accept-eyebrow) {\n  margin: 10px 0 0;\n  color: var(--invite-muted);\n  font-size: 14px;\n  line-height: 1.55;\n}\n\n.invite-accept-summary {\n  margin: 0 0 22px;\n  padding: 4px 14px;\n  background: var(--invite-subtle);\n  border: 1px solid var(--invite-border);\n  border-radius: 6px;\n}\n\n.invite-accept-summary > div {\n  display: grid;\n  grid-template-columns: 116px minmax(0, 1fr);\n  gap: 14px;\n  padding: 10px 0;\n  border-bottom: 1px solid var(--invite-border);\n}\n\n.invite-accept-summary > div:last-child {\n  border-bottom: 0;\n}\n\n.invite-accept-summary dt {\n  color: var(--invite-muted);\n  font-size: 12px;\n}\n\n.invite-accept-summary dd {\n  overflow: hidden;\n  margin: 0;\n  color: var(--invite-text);\n  font-size: 12px;\n  font-weight: 500;\n  text-align: right;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.invite-accept-tabs {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 3px;\n  padding: 3px;\n  margin-bottom: 14px;\n  background: var(--invite-subtle);\n  border: 1px solid var(--invite-border);\n  border-radius: 6px;\n}\n\n.invite-accept-tabs button {\n  min-height: 34px;\n  border: 0;\n  border-radius: 4px;\n  background: transparent;\n  color: var(--invite-muted);\n  font: inherit;\n  font-size: 12px;\n  font-weight: 550;\n  cursor: pointer;\n}\n\n.invite-accept-tabs button[aria-selected='true'] {\n  background: var(--invite-panel);\n  color: var(--invite-text);\n  box-shadow: inset 0 0 0 1px var(--invite-border);\n}\n\n.invite-accept-tabs button:disabled {\n  cursor: wait;\n  opacity: 0.55;\n}\n\n.invite-accept-form {\n  display: grid;\n  gap: 13px;\n}\n\n.invite-accept-form label {\n  display: grid;\n  gap: 6px;\n  color: var(--invite-muted);\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.invite-accept-form input {\n  width: 100%;\n  height: 40px;\n  box-sizing: border-box;\n  padding: 0 11px;\n  border: 1px solid var(--invite-border);\n  border-radius: 5px;\n  outline: none;\n  background: var(--invite-subtle);\n  color: var(--invite-text);\n  font: inherit;\n  font-size: 13px;\n  transition: border-color 120ms ease, box-shadow 120ms ease;\n}\n\n.invite-accept-form input:focus {\n  border-color: color-mix(in srgb, var(--invite-text) 45%, transparent);\n  box-shadow: 0 0 0 2px color-mix(in srgb, var(--invite-text) 8%, transparent);\n}\n\n.invite-accept-form input[readonly] {\n  color: var(--invite-muted);\n  cursor: default;\n}\n\n.invite-accept-password-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n}\n\n.invite-accept-primary,\n.invite-accept-secondary,\n.invite-accept-google {\n  display: inline-flex;\n  min-height: 40px;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 0 14px;\n  border-radius: 5px;\n  font: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 120ms ease, border-color 120ms ease, opacity 120ms ease;\n}\n\n.invite-accept-primary {\n  width: 100%;\n  margin-top: 3px;\n  border: 1px solid #f2f2f2;\n  background: #f2f2f2;\n  color: #141518;\n}\n\n.invite-accept-primary:hover:not(:disabled) {\n  background: #ffffff;\n  border-color: #ffffff;\n}\n\n.invite-accept-primary:disabled {\n  opacity: 0.55;\n  cursor: wait;\n}\n\n.invite-accept-secondary:disabled,\n.invite-accept-google:disabled {\n  opacity: 0.55;\n  cursor: wait;\n}\n\n.invite-accept-tabs button:focus-visible,\n.invite-accept-primary:focus-visible,\n.invite-accept-secondary:focus-visible,\n.invite-accept-google:focus-visible {\n  outline: 2px solid color-mix(in srgb, var(--invite-text) 65%, transparent);\n  outline-offset: 2px;\n}\n\n.invite-accept-secondary,\n.invite-accept-google {\n  border: 1px solid var(--invite-border);\n  background: var(--invite-subtle);\n  color: var(--invite-text);\n}\n\n.invite-accept-secondary:hover,\n.invite-accept-google:hover {\n  background: color-mix(in srgb, var(--invite-subtle) 75%, var(--invite-text) 7%);\n}\n\n.invite-accept-google {\n  width: 100%;\n}\n\n.invite-accept-google img {\n  width: 16px;\n  height: 16px;\n}\n\n.invite-accept-divider {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 15px 0;\n  color: var(--invite-muted);\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n\n.invite-accept-divider::before,\n.invite-accept-divider::after {\n  height: 1px;\n  flex: 1;\n  background: var(--invite-border);\n  content: '';\n}\n\n.invite-accept-account {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 11px 12px;\n  margin-bottom: 12px;\n  background: var(--invite-subtle);\n  border: 1px solid var(--invite-border);\n  border-radius: 5px;\n}\n\n.invite-accept-account div {\n  display: grid;\n  gap: 3px;\n  min-width: 0;\n}\n\n.invite-accept-account span {\n  color: var(--invite-muted);\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.invite-accept-account strong {\n  overflow: hidden;\n  font-size: 13px;\n  text-overflow: ellipsis;\n}\n\n.invite-accept-account--mismatch {\n  border-color: rgba(217, 119, 87, 0.45);\n}\n\n.invite-accept-mismatch p,\n.invite-accept-transition p {\n  margin: 0 0 12px;\n  color: var(--invite-muted);\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n.invite-accept-transition {\n  padding: 14px;\n  border: 1px solid rgba(217, 156, 87, 0.45);\n  border-radius: 6px;\n  background: rgba(217, 156, 87, 0.07);\n}\n\n.invite-accept-transition--blocked {\n  border-color: rgba(217, 119, 87, 0.5);\n  background: rgba(217, 119, 87, 0.075);\n}\n\n.invite-accept-transition-heading {\n  display: flex;\n  align-items: flex-start;\n  gap: 9px;\n  margin-bottom: 12px;\n}\n\n.invite-accept-transition-heading > svg {\n  flex: 0 0 auto;\n  margin-top: 1px;\n  color: #d99c57;\n}\n\n.invite-accept-transition--blocked .invite-accept-transition-heading > svg {\n  color: #d97757;\n}\n\n.invite-accept-transition-heading > div {\n  display: grid;\n  gap: 3px;\n}\n\n.invite-accept-transition-heading span,\n.invite-accept-transition-route small {\n  color: var(--invite-muted);\n  font-size: 9px;\n  font-weight: 650;\n  letter-spacing: 0.07em;\n  line-height: 1.2;\n  text-transform: uppercase;\n}\n\n.invite-accept-transition-heading strong {\n  font-size: 13px;\n  font-weight: 620;\n  line-height: 1.35;\n}\n\n.invite-accept-transition-route {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 20px minmax(0, 1fr);\n  align-items: center;\n  gap: 8px;\n  padding: 9px;\n  margin-bottom: 11px;\n  border: 1px solid var(--invite-border);\n  border-radius: 5px;\n  background: color-mix(in srgb, var(--invite-panel) 72%, transparent);\n}\n\n.invite-accept-transition-route > svg {\n  color: var(--invite-muted);\n}\n\n.invite-accept-transition-route > div {\n  display: grid;\n  min-width: 0;\n  gap: 3px;\n}\n\n.invite-accept-org-name {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.invite-accept-org-icon {\n  display: grid;\n  width: 24px;\n  height: 24px;\n  flex: 0 0 auto;\n  overflow: hidden;\n  place-items: center;\n  border: 1px solid var(--invite-border);\n  border-radius: 5px;\n  background: var(--invite-panel);\n  color: var(--invite-text);\n  font-size: 10px;\n  font-weight: 650;\n}\n\n.invite-accept-org-icon img {\n  width: 100%;\n  height: 100%;\n  padding: 3px;\n  object-fit: contain;\n  background: #ffffff;\n}\n\n.invite-accept-transition-route > .invite-accept-transition-org {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n}\n\n.invite-accept-transition-org > div {\n  display: grid;\n  min-width: 0;\n  gap: 3px;\n}\n\n.invite-accept-transition-route strong,\n.invite-accept-transition-route span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.invite-accept-transition-route strong {\n  color: var(--invite-text);\n  font-size: 12px;\n  font-weight: 580;\n}\n\n.invite-accept-transition-route span {\n  color: var(--invite-muted);\n  font-size: 10px;\n}\n\n.invite-accept-transition-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.invite-accept-transition-actions .invite-accept-primary {\n  width: auto;\n  margin: 0;\n}\n\n.invite-accept-error {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 10px 11px;\n  margin-top: 13px;\n  border: 1px solid rgba(217, 119, 87, 0.4);\n  border-radius: 5px;\n  background: rgba(217, 119, 87, 0.07);\n  color: #e1a18d;\n  font-size: 12px;\n  line-height: 1.4;\n}\n\n.invite-accept-error svg {\n  flex: 0 0 auto;\n  margin-top: 1px;\n}\n\n.invite-accept-footnote {\n  margin: 18px 0 0;\n  color: var(--invite-muted);\n  font-size: 10px;\n  line-height: 1.45;\n  text-align: center;\n}\n\n.invite-accept-result {\n  display: flex;\n  min-height: 285px;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n\n.invite-accept-result .invite-accept-primary,\n.invite-accept-result .invite-accept-secondary {\n  width: auto;\n  margin-top: 22px;\n}\n\n.invite-accept-status-icon {\n  display: grid;\n  width: 42px;\n  height: 42px;\n  place-items: center;\n  margin-bottom: 18px;\n  border: 1px solid var(--invite-border);\n  border-radius: 50%;\n  background: var(--invite-subtle);\n}\n\n.invite-accept-status-icon--success {\n  color: #7fca9a;\n}\n\n.invite-accept-status-icon--error {\n  color: #e1a18d;\n}\n\n.invite-accept-spinner {\n  width: 28px;\n  height: 28px;\n  margin-bottom: 20px;\n  border: 2px solid var(--invite-border);\n  border-top-color: var(--invite-text);\n  border-radius: 50%;\n  animation: invite-spin 700ms linear infinite;\n}\n\n@keyframes invite-spin {\n  to { transform: rotate(360deg); }\n}\n\n@media (max-width: 560px) {\n  .invite-accept-page {\n    align-items: start;\n    padding: 16px 12px;\n  }\n\n  .invite-accept-card {\n    padding: 22px 18px;\n  }\n\n  .invite-accept-brand {\n    margin-bottom: 22px;\n  }\n\n  .invite-accept-password-row {\n    grid-template-columns: 1fr;\n  }\n\n  .invite-accept-summary > div {\n    grid-template-columns: 96px minmax(0, 1fr);\n  }\n\n  .invite-accept-transition-actions {\n    align-items: stretch;\n    flex-direction: column-reverse;\n  }\n\n  .invite-accept-transition-actions .invite-accept-primary,\n  .invite-accept-transition-actions .invite-accept-secondary {\n    width: 100%;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .invite-accept-spinner { animation-duration: 1.4s; }\n  .invite-accept-primary,\n  .invite-accept-secondary,\n  .invite-accept-google { transition: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
